(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(5838);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(714);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  padding: 0px 30px 150px;\n  max-width: 800px;\n  margin: 0 auto;\n\n  .title {\n    font-size: 100px;\n    line-height: 1;\n    padding-bottom: 20px;\n    margin: 0;\n    font-style: normal;\n    font-weight: 900;\n  }\n\n  .sub-title {\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 20px;\n    font-weight: 400;\n  }\n\n  .content {\n    font-size: 16px;\n    font-weight: 200;\n  }\n\n  .back-to-home {\n    display: inline-block;;\n    margin-top: 40px;\n    padding: 20px 30px;\n    font-size: 16px;\n    line-height: 1;\n    letter-spacing: 0.02em;\n    border-radius: 40px;\n    color: #000;\n    transition: all 500ms ease;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n\n  @media screen and (min-width: ",
        ") {\n    .title {\n      font-size: 150px;\n      font-size: 10vw;\n    }\n\n    .sub-title {\n      font-size: 34px;\n      font-size: 1.75vw;\n      margin-bottom: 30px;\n    }\n\n    .content {\n      font-size: 20px;\n      font-size: 1.15vw;\n    }\n\n    .back-to-home {\n      font-size: 20px;\n      font-size: 1.15vw;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var NotFound = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Error, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "title",
                children: "404"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                className: "sub-title",
                children: "Diese Seite wurde nicht gefunden!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: "content",
                children: "Die gesuchte Seite konnte nicht gefunden werden. Sie wurde m\xf6glicherweise entfernt, umbenannt oder existierte von vornherein nicht."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    className: "back-to-home",
                    children: "Zur\xfcck zu home"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFound);
var Error = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-94e788a-0"
})(_templateObject(), function(props) {
    return props.theme.breakPoints.desktop;
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,774,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);